module.exports = __webpack_public_path__ + "assets/RussoOne-Regular.0da86ea66deb71e42ef2d751ef58ed5ffd5af3793d6fd192bbfe54bc57a906f5.woff";